import { connectPlatformV7, getShopV7Api, initGemPages } from "@/services/instantApi";

export default {
  methods: {
    async connectGemPagesV7(retry = 0) {

      const shopV7 = await getShopV7Api()
      const shopIdNotfound = shopV7 && shopV7.shopID && shopV7.shopID != "0"
      const userNotExist = shopV7 && shopV7.code == 400417
      const shopNotConnected = shopV7 && shopV7.status != 'CONNECTED'
      if (shopIdNotfound && !userNotExist) {
        this.$store.commit("account/SET_INSTANT_SHOP_ID", shopV7.shopID);
        this.$store.commit("account/SET_INSTANT_SHOP_TOKEN", shopV7.token);
        if (shopNotConnected) {
          await connectPlatformV7();
        }
      } else if (retry < 3){
        // auto init gempages v7
        await initGemPages("GEMPAGESV7");
        await this.connectGemPagesV7(retry + 1);
      }
    }
  }
};
